<template>
    <div id="menu-search">
        <!-- Accion buscar -->
        <el-menu>
            <el-menu-item-group >
                <el-menu-item index="1-1" @click="clickSearch()">
                    <i class="el-icon-search"></i> <span slot="title">Buscador</span>
                </el-menu-item>
            </el-menu-item-group>
        </el-menu>

        <!-- Filtros -->
        <Porlet
            v-if="modal"
            :porlet="{ tipo: 'porlet' }"
            :shadow="false"
            :divider="false"
            :focus="true"
            :autosave="false"
            :ficha="ficha"
            :modal="modal"
            :objects="modal.objects"
            :showShadow="false"/>
    </div>
</template>

<script>
    import {
		getBuscadorFiltrosEstructura
	} from '@/helpers/api'

	export default {
        name: 'MenuSearch',
        props: {
            ficha: Object,
            url: String
        },
        data() {
            return {
                modal: null
            }
        },
        watch: {
            'modal.data': {
                handler() {
                    
                    // Controlar campo "Enter"
                    let campos = Object.keys(this.modal.data)

                    let campos_filter = campos.filter(f => f.split('_').includes('filter'))

                    let _self = this
                    campos_filter.forEach(campo => {

                        // Mostrar campo que esta oculto
                        let campo_entre = campos.find(f => f == campo.replace('_filter','_entre'))
                        
                        if (campo_entre) {
                            
                            if (_self.modal.data[campo].value != 5) _self.modal.data[campo_entre].value = ""

                            _self.modal.data[campo_entre].visible = (_self.modal.data[campo].value == 5)
                        }
                    })

                    // Controlar campo addfilter
                    if (this.modal.data.addfilter && this.modal.data.addfilter.value != "") {
                        let addfilter = this.modal.data.addfilter
                        this.modal.data[addfilter.value].visible = true
                        this.modal.data[addfilter.value].asistente = 1
                        
                        // Quitar opción
                        let optionExist = addfilter.options.findIndex(f => f.value == addfilter.value)
                        if (!!~optionExist) {
                            addfilter.options[optionExist].disabled = true
                            addfilter.value = ""
                        }
                    }

                },
                deep: true
            }
        },
        methods: {

            // Click en el boton
            async clickSearch() {

                // Comprobar si hay acciones para el buscador
                if (this.ficha && this.ficha) {

                    // Petición a back
                    let data = {
                        attr: {
                            title: "Filtros",
                            buttons: [
                                {
                                    icon:"",
                                    title : "Buscar",
                                    accion : "entidad/cliente"
                                }
                            ]
                        },
                        data: {
                            __description: {
                                "attr": {
                                    "divider": true,
                                    "col": 24
                                },
                                "format": "text",
                                "obligatorio": 1,
                                "class": "",
                                "textpre": "",
                                "textpos": "",
                                "title": "Descripción",
                                "title2": "",
                                "subtitle": "",
                                "value": "",
                                "asistente": 1,
                                "__internacionalizacion": "",
                                "order": 1,
                                "state": "editable",
                                "porlet": 1,
                                "actions": [],
                                "visible" : true,
                                "placeholder": "Introduce valor",
                                "labelposition": "top"
                            },
                            __proyect: {
                                "attr": {
                                    "divider": true,
                                    "col": 24
                                },
                                "format": "text",
                                "obligatorio": 1,
                                "class": "",
                                "textpre": "",
                                "textpos": "",
                                "title": "Proyecto",
                                "title2": "",
                                "subtitle": "",
                                "value": "",
                                "asistente": 0,
                                "__internacionalizacion": "",
                                "order": 1,
                                "state": "editable",
                                "porlet": 1,
                                "actions": [],
                                "visible" : false,
                                "placeholder": "Introduce valor",
                                "labelposition": "top"
                            }
                        }
                    }

                    try {

                        let resp = await getBuscadorFiltrosEstructura()
                        console.log('resp buscador estructura: ', resp)
                        
                        if (resp && resp.status == 200 && resp.data) {
                            
                            // Crear formulario
                            let objects = Object.keys(resp.data.data)
                            .reduce((acum, newval) => {

                                // Objeto campo "addfilter": Contiene todos los campos con "asistente" a 0
                                if (!acum.find(f => f.key == 'addfilter')) {
                                    let obj_addfilter = {
                                        "attr": {
                                            "divider": true,
                                            "col": 24
                                        },
                                        "format": "list",
                                        "obligatorio": 0,
                                        "value": "",
                                        "title": "Añadir filtro",
                                        "asistente": 1,
                                        "state": "editable",
                                        "order": 9999,
                                        "options": [],
                                        "visible" : true,
                                        "placeholder": "Seleccione",
                                        "labelposition": "top"
                                    }
                                    obj_addfilter.key = `addfilter`
                                    acum.push(obj_addfilter)
                                }

                                // Objeto campo base
                                let obj_base = resp.data.data[newval]
                                obj_base.key = newval
                                acum.push(obj_base)

                                if (obj_base.asistente == 0) {
                                    let acum_addfilter = acum.find(f => f.key == 'addfilter')
                                    acum_addfilter.options.push({
                                        label: obj_base.title,
                                        value: obj_base.key,
                                        disabled: false
                                    })
                                }   

                                // Objeto campo "filtro"
                                let obj_filtro = {
                                    "attr": {
                                        "divider": true,
                                        "col": 24
                                    },
                                    "format": "list",
                                    "obligatorio": 1,
                                    "order": 1,
                                    "value": "",
                                    "asistente": 1,
                                    "state": "editable",
                                    "options": [{
                                        "label": "igual",
                                        "value": "1" 
                                    },{
                                        "label": "contiene",
                                        "value": "2" 
                                    },{
                                        "label": "mayor a",
                                        "value": "3" 
                                    },{
                                        "label": "menor a",
                                        "value": "4" 
                                    },{
                                        "label": "entre",
                                        "value": "5" 
                                    }],
                                    "visible" : false,
                                    "placeholder": "Seleccione",
                                    "labelposition": "top"
                                }
                                obj_filtro.key = `${newval}_filter`
                                acum.push(obj_filtro)

                                // Objeto campo "entre"
                                let obj_entre = JSON.parse(JSON.stringify(obj_base))
                                obj_entre.key = `${newval}_entre`
                                obj_entre.title = ""
                                obj_entre.visible = false
                                acum.push(obj_entre)

                                return acum
                            }, [])
                            .sort((a,b) => a.order - b.order)

                            let data_objects = objects.reduce((acum, newval) => {
                                acum[newval.key] = newval
                                return acum
                            }, {})
                            
                            this.modal = {
                                attr: resp.data.attr,
                                data: data_objects,
                                objects
                            }
                            
                        } else {
                            console.log('ERROR estructura busacdor')
                        }

                    } catch (e) {
                        console.log('CATCH Error estructura buscador :: ',e)
                    }

                } else {
                    this.$emit('openSearch')
                }
            }
        }
	}
</script>

<style lang="scss">
#menu-search {
    .porlet-content {
        margin-left: 15px!important;
        .formulario {
            padding: 0px 8px;
            background-color: transparent!important;
        }
    }
}
</style>